/**
 * @file 任务 actions
 * @author gaoxunchen
 */

import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

// 任务期任务汇总
export const getActiveSummary = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_ongoing_summary');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};

// 已结束任务汇总
export const getPastSummary = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_finished_summary');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};

// 策略汇总
export const getStrategySummary = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_strategy_summary');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};
